// extracted by mini-css-extract-plugin
export var equalColumn = "_iu-0";